import {Component, OnInit} from '@angular/core';
import {Response} from '@angular/http';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {JhiAlertComponent, Principal} from '../../shared';
import {TypeEtudiantEnumeration, UserEnEchange, UserEnEchangeService} from '../../entities/user-en-echange';
import {Subscription} from 'rxjs/Rx';
import {GrhumService, Pays} from '../../entities/grhum';
import {ActivatedRoute} from '@angular/router';
import {toInteger} from '@ng-bootstrap/ng-bootstrap/util/util';


@Component({
    selector: 'jhi-user-echange',
    templateUrl: './user-echange.component.html'
})
export class UserEchangeMgmtComponent implements OnInit {

    currentAccount: any;
    users: UserEnEchange[];
    error: any;
    success: any;
    paysListe: Pays[];
    public typeEtudiant: Number = 0;
    typeEtudiantEnumeration = TypeEtudiantEnumeration;
    private parametersTypeEtudiantObservable: Subscription;

    constructor(private jhiLanguageService: JhiLanguageService,
                private userEchangeService: UserEnEchangeService,
                private alertService: AlertService,
                private principal: Principal,
                private eventManager: EventManager,
                public grhumService: GrhumService,
                private route: ActivatedRoute) {
        this.jhiLanguageService.setLocations(['user-echange']);
        this.parametersTypeEtudiantObservable = this.route.queryParams.subscribe(params => {
            try {
                // lorsque l'on ferme les pop up on perd le type d'étudiant--> donc on reutilise la valeur précédente du paramètre
                if (!(isNaN(params['typeEtudiant'])
                    || toInteger(params['typeEtudiant']).toString().length != params['typeEtudiant'].length)) {
                    this.typeEtudiant = toInteger(params['typeEtudiant']);
                }
            } catch (e) {
            }
            this.loadAll();
        });
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
            this.registerChangeInUsers();
        });
        this.grhumService.queryPays().subscribe(
            (res: Response) => {
                this.paysListe = res.json();
            }, (res: Response) => this.onError(res.json()));
    }

    ngOnDestroy() {
        if (this.parametersTypeEtudiantObservable != null) {
            this.parametersTypeEtudiantObservable.unsubscribe();
        }
    }

    registerChangeInUsers() {
        this.eventManager.subscribe('userListModification', (response) => this.loadAll());
    }

    setActive(user, isActivated) {
        user.activated = isActivated;

        this.userEchangeService.update(user).subscribe(
            response => {
                if (response != null) {
                    this.error = null;
                    this.success = 'OK';
                    this.loadAll();
                } else {
                    this.success = null;
                    this.error = 'ERROR';
                }
            });
    }


    loadAll() {
        this.userEchangeService.query(this.typeEtudiant).subscribe(
            (res: Response) => this.onSuccess(res.json(), res.headers),
            (res: Response) => this.onError(res.json())
        );
    }

    private onSuccess(data, headers) {
        this.users = data;
    }

    private onError(error) {
        JhiAlertComponent.onError(this.alertService, error);
    }

    public findPaysDansListe(codePays: string): Pays {
        return GrhumService.findPaysDansListe(this.paysListe, codePays);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-echange/user-echange.component.ts